import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Params } from '@angular/router';

import { Animation, mdTransitionAnimation } from '@ionic/angular';

import { NavigationService } from '../../../core/services/navigation.service';
import { PlatformService } from '../../../core/services/ssr/platform.service';

import { browserEmptyTransitionAnimation } from '../../../core/transitions/browser-page-transition';

@Component({
  selector: 'app-router-link',
  templateUrl: './router-link.component.html',
  styleUrls: ['./router-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RouterLinkComponent implements OnInit {
  @Input()
  public preserveFragmentAndQueryParams?: boolean;

  @Input()
  public fragment?: string | number;

  @Input()
  public queryParams?: Params;

  @Input()
  public state?: Record<string, unknown>;

  public isBrowser: boolean;
  public routerLink: Array<string | number>;
  public countryLanguageUrlSegment: string;

  public routerAnimation: (_: unknown, opts: unknown) => Animation;

  constructor(private platformService: PlatformService, private navigationService: NavigationService) {}

  @Input()
  public set path(path: Array<string | number>) {
    this.routerLink = [this.navigationService.getCountryLanguageUrlSegment(), ...(path && path.length ? path : [])];
  }

  ngOnInit() {
    this.isBrowser = this.platformService.isBrowser;
    this.routerAnimation = this.isBrowser ? browserEmptyTransitionAnimation : mdTransitionAnimation;
  }
}
